import { OAuth2WebClient } from 'regula-sdk';
import {useEffect, useLayoutEffect, useState} from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import useAlert from '../../component/Alert/useAlert';
import AuthAPIService from '../../services/auth.api.service';
import {RegulaQRCode} from '../../component/RegulaQRCode';

const theme = createTheme();

const client = new OAuth2WebClient({
  clientId: process.env.REACT_APP_REGULA_CLIENT_ID,
  redirectUri: process.env.REACT_APP_REGULA_REDIRECT_URI,
  serverUrl: process.env.REACT_APP_REGULA_SERVER_URL,
});

export const Login = () => {
  const [disabled, setDisabled] = useState(false);
  const [code, setCode] = useState(null);

  const navigate = useNavigate();
  const { showErrorAlert } = useAlert();

  const handleSubmit = async (event) => {
    event.preventDefault();

    setDisabled(true);

    const data = new FormData(event.currentTarget);
    const email = data.get('email');
    const password = data.get('password');

    try {
      await AuthAPIService.reqToLogin(email, password);
      navigate('/dashboard/add-context');
    } catch (err) {
      showErrorAlert(err.response.data.message);
    }

    setDisabled(false);
  }

  useLayoutEffect(() => {
    const key = Date.now().toString();

    client.genQRCode(key)
      .then((value) => setCode(value))
      .catch((e) => console.error('error generate qr-code', e));

    client.subscribe(key, async (value) => {
      await client.unsubscribe();

      await AuthAPIService.reqToLoginWithCode(value);

      navigate('/dashboard/add-context');
    });

    return () => {
      client.unsubscribe();
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Login
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate={false} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="password"
              label="Password"
              name="password"
              type="password"
              autoComplete="password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={disabled}
            >
              Login
            </Button>
            <Grid container>
              <Grid item xs>
                <Link component={NavLink} to="restore-password" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs>
                <RegulaQRCode code={code} />
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Link component={NavLink} to="chainscan" variant="body2">
            Public Chainscan page
          </Link>
        </Box>
      </Container>
    </ThemeProvider>
  );
};
